import { render, staticRenderFns } from "./ContentAreaAddEditModal.vue?vue&type=template&id=3996b3c4&scoped=true"
import script from "./ContentAreaAddEditModal.vue?vue&type=script&lang=js"
export * from "./ContentAreaAddEditModal.vue?vue&type=script&lang=js"
import style0 from "./ContentAreaAddEditModal.vue?vue&type=style&index=0&id=3996b3c4&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./ContentAreaAddEditModal.vue?vue&type=style&index=2&id=3996b3c4&prod&lang=css"
import style3 from "./ContentAreaAddEditModal.vue?vue&type=style&index=3&id=3996b3c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3996b3c4",
  null
  
)

export default component.exports